// @flow

export const mapStationToGreenCarsPricing = (
  station: string,
  tickeType: string,
): number => {
  let price = null;

  switch (station) {
    case 'tokyo':
      price = 4560;
      break;
    case 'shinagawa':
      price = 4730;
      break;
    case 'shibuya':
      price = 4730;
      break;
    case 'shinjuku':
      price = 4730;
      break;
    case 'ikebukuro':
      price = 4730;
      break;
    case 'omiya':
      price = 5380;
      break;
    case 'yokohama':
      price = 5830;
      break;
    case 'ofuna':
      price = 6160;
      break;
    default:
      return 0;
  }

  return tickeType === 'round_trip' ? price * 2 : price;
};

export const mapStationToOrdinaryCarsPricing = (
  station: string,
  tickeType: string,
): number => {
  let price = null;

  switch (station) {
    case 'tokyo':
      price = 3020;
      break;
    case 'shinagawa':
      price = 3190;
      break;
    case 'shibuya':
      price = 3190;
      break;
    case 'shinjuku':
      price = 3190;
      break;
    case 'ikebukuro':
      price = 3190;
      break;
    case 'omiya':
      price = 3840;
      break;
    case 'yokohama':
      price = 4290;
      break;
    case 'ofuna':
      price = 4620;
      break;
    default:
      return 0;
  }

  return tickeType === 'round_trip' ? 4000 : price;
};

export const mapStationToStationName = (station: string): string => {
  switch (station) {
    case 'narita_airport_terminal_1':
      return 'Terminal 1';
    case 'narita_airport_terminal_2_3':
      return 'Terminal 2・3';
    case 'narita':
      return 'Narita';
    case 'sakura':
      return 'Sakura';
    case 'yotsukaido':
      return 'Yotsukaido';
    case 'chiba':
      return 'Chiba';
    case 'tokyo':
      return 'Tokyo';
    case 'shinagawa':
      return 'Shinagawa';
    case 'shibuya':
      return 'Shibuya';
    case 'shinjuku':
      return 'Shinjuku';
    case 'ikebukuro':
      return 'Ikebukuro';
    case 'omiya':
      return 'Omiya';
    case 'musashi_kosugi':
      return 'Musashi-Kosugi';
    case 'yokohama':
      return 'Yokohama';
    case 'totsuka':
      return 'Totsuka';
    case 'ofuna':
      return 'Ofuna';
    case 'kichijoji':
      return 'Kichijoji';
    case 'mitaka':
      return 'Mitaka';
    case 'kokubunji':
      return 'Kokubunji';
    case 'tachikawa':
      return 'Tachikawa';
    case 'hachioji':
      return 'Hachioji';
    case 'takao':
      return 'Takao';
    default:
      return 'Not found';
  }
};

export const convertTimeToUsLocale = (timeString: string): string => {
  if (typeof timeString === 'undefined') {
    return '';
  }

  const today = new Date().toDateString();
  const date = new Date(`${today} ${timeString}:00`);

  const options = {
    hour: 'numeric',
    minute: 'numeric',
  };

  return new Intl.DateTimeFormat('en-US', options).format(date);
};

export const fetchTravelTime = (firstStop: any, lastStop: any): string => {
  if (!firstStop || !lastStop) {
    return '';
  }

  let startTime = firstStop.time;
  let endTime = lastStop.time;

  const today = new Date().toDateString();
  const start = new Date(`${today} ${startTime}:00`);
  const end = new Date(`${today} ${endTime}:00`);
  const travelTimeInMinutes = Math.abs(
    Math.round((end.getTime() - start.getTime()) / 1000 / 60),
  );

  const hours = Math.floor(travelTimeInMinutes / 60);
  const min = Math.round((travelTimeInMinutes / 60 - hours) * 60);

  return `${hours} h ${min} m`;
};

export const mapOperationDateToMessage = (value: string): string => {
  switch (value) {
    case 'W':
      return 'This train operates on Weekdays (Mon-Fri) only';
    case 'S':
      return 'This train operates on Saturdays only';
    case 'H':
      return 'This train operates on Sundays and holidays only';
    case 'SH':
      return 'This train operates on Weekends (Sat-Sun) and holidays only';
    default:
      return '';
  }
};

export const getDefaultTime = (): string => {
  const currentTimeInHours = new Date().getHours();
  const time =
    currentTimeInHours >= 5 && currentTimeInHours <= 21
      ? currentTimeInHours
      : 7;

  function addZero(i: number) {
    let output = i;

    if (i < 10) {
      output = `0${i}`;
    }
    return `${output}:00`;
  }

  return addZero(time);
};

// const stopsLabel = stops
//   .reduce((stops, currStop) => {
//     const station = mapStationToStationName(currStop.station);

//     if (whitelistStations.includes(station)) {
//       stops.push(station);
//     }

//     return stops;
//   }, [])
//   .join(', ');
